import { render, staticRenderFns } from "./EditBlogCategory.vue?vue&type=template&id=e82c5524&scoped=true&"
import script from "./EditBlogCategory.vue?vue&type=script&lang=js&"
export * from "./EditBlogCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82c5524",
  null
  
)

export default component.exports